import request from '@/config/axios'

/** 评价状态标签 */
export const REVIEW_STATUS_LABELS: Record<number, string> = {
  0: '显示中',
  1: '已屏蔽'
}

/** 订单评价 VO（平台监管视图） */
export interface OrderReviewVo {
  id: number
  tradeOrderId: number
  orderNo?: string
  masterId: number
  masterName?: string
  userName?: string
  rating: number
  content?: string
  reply?: string
  status: number
  shieldReason?: string
  createTime?: string
}

export const OrderReviewApi = {
  // 评价分页（师傅姓名模糊/星级/状态筛选）
  getPage: (params: { pageNo?: number; pageSize?: number; masterName?: string; rating?: number; status?: number }) => {
    return request.get({ url: '/xuanxue/order-review/page', params })
  },
  // 屏蔽评价（原因必填；屏蔽后不参与均分/好评率聚合）
  shield: (id: number, reason: string) => {
    return request.put({ url: '/xuanxue/order-review/shield', params: { id, reason } })
  },
  // 恢复评价（重新参与聚合并恢复展示）
  recover: (id: number) => {
    return request.put({ url: '/xuanxue/order-review/recover', params: { id } })
  }
}
